<template>
  <div
    data-component="FoldingText"
    class="folding-text-component"
  >
    <div
      class="text"
      :class="{ 'folding-text': !textExpanded }"
      v-html="text"
    />

    <button
      v-show="!textExpanded"
      class="expand-button"
      type="button"
      @click="textExpanded = !textExpanded"
    >
      leer más
    </button>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue'

  interface PropsInterface {
    text: string
    lineClamp?: number
  }

  withDefaults(defineProps<PropsInterface>(), {
    lineClamp: 2
  })

  const textExpanded = ref(false)
</script>

<style lang="scss" scoped>
  .folding-text-component {
    position: relative;
    color: $color-black-200;

    .text {
      display: block;
      margin-bottom: $spacing-xs;

      &.folding-text {
        max-width: $size-full;
        overflow: hidden;
        max-height: $size-45; // line-height * 2 = (1.4 * 2)
        display: -webkit-box;
        line-clamp: v-bind(lineClamp);
        -webkit-line-clamp: v-bind(lineClamp);
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
      }
    }

    .expand-button {
      background-color: $color-neutral-00;
      z-index: $z-index-02;
      line-height: $line-height-140p;
      color: $color-primary;
      text-decoration: underline;
      transition: all 0.3s ease;

      &:hover {
        cursor: pointer;
        color: $color-primary-dark;
      }
    }
  }
</style>
